export default __webpack_public_path__ + "static/media/03.96ab60cc.jpeg";